import React from "react";

export default function ConfirmModal({ state, onClose }) {
  if (!state) return null;

  const { title, message, onConfirm, confirmText, confirmVariant } = state;

  return (
    <div className="cms-modal-backdrop" role="dialog" aria-modal="true" onClick={onClose} style={{ padding: "16px" }}>
      <div className="cms-modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: "500px", width: "100%" }}>
        <h3>{title}</h3>
        <p>{message}</p>
        <div className="cms-modal__actions">
          <button type="button" className="btn btn--outline" onClick={onClose}>
            Cancel
          </button>
          <button
            type="button"
            className={`btn ${confirmVariant === "danger" ? "btn--accent" : "btn--primary"}`}
            style={confirmVariant === "danger" ? { background: "#c62828", borderColor: "#c62828" } : {}}
            onClick={async () => {
              await onConfirm();
              onClose();
            }}
          >
            {confirmText || "Confirm"}
          </button>
        </div>
      </div>
    </div>
  );
}
